<template>
  <div>
    <h1 class="text-center">{{ schema.$title }}</h1>

    <panel :title="schema.data.applicant.$title">
      <w-radio-list class="form-group" :model="schema.data.creatorType" :values="dictionary.creatorTypes" />

      <person-with-pesel :model="schema.data.applicant">
        <div class="row form-group">
          <div class="col-6">
            <w-input :model="schema.data.applicant.email" @paste="$event.preventDefault()" />
          </div>

          <div class="col-6">
            <w-input :model="schema.data.applicant.emailConfirm" @paste="$event.preventDefault()" />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-6">
            <w-input :model="schema.data.applicant.phoneNumber" />
          </div>
        </div>
      </person-with-pesel>
    </panel>

    <panel :title="schema.data.tenderer.$title">
      <person-with-pesel
        :model="schema.data.tenderer"
        :has-address="false"
        :disabled="{
          firstName: schema.data.creatorType.$model === 1,
          lastName: schema.data.creatorType.$model === 1,
          pesel: schema.data.creatorType.$model === 1,
          birthDate: schema.data.creatorType.$model === 1 || hasPesel
        }"
      >
        <div>
          <w-radio-list :model="schema.data.tenderer.studentType" :values="dictionary.studentTypes" />
        </div>
      </person-with-pesel>
    </panel>

    <panel :title="schema.data.school.$title">
      <school-picker-duplikaty :school-model="schema.data.school" :with-parents="true" />
    </panel>

    <panel :title="schema.data.details.$title">
      <div>
        <p class="label">Rodzaj dokumentu *</p>

        <w-error :model="schema.data.details.documentType" />

        <template v-for="(documentType, index) in documentTypes">
          <w-checkbox
            :key="'option_' + index"
            :model="schema.data.details.documentType"
            :value="documentType.value"
            :title="documentType.text"
            :show-error="false"
            @input="toggleDocumentYear(documentType)"
          />

          <w-select
            v-if="documentType.schoolClassField"
            :key="'school_class_' + index"
            class="form-group"
            :model="schema.data.details[documentType.schoolClassField]"
            :values="schoolClassess"
          />

          <w-input
            v-if="isDocumentTypeSelected(documentType) && documentYearModel(documentType)"
            :key="'document_year_' + index"
            class="form-group"
            :model="documentYearModel(documentType)"
          />
        </template>
      </div>

      <w-radio-list
        class="form-group mt-4"
        :model="schema.data.details.deliveryMethod"
        :values="dictionary.deliveryMethods"
      />
    </panel>

    <panel v-if="!schema.data.details.receiver.$disabled" :title="schema.data.details.receiver.$title">
      <div class="row form-group">
        <w-input class="col-md-6" :model="schema.data.details.receiver.firstName" />

        <w-input class="col-md-6" :model="schema.data.details.receiver.lastName" />

        <w-input class="col-md-6" :model="schema.data.details.receiver.phoneNumber" />
      </div>
    </panel>

    <panel :title="schema.data.paymentInformation.$title">
      <div v-html="schema.data.paymentInformation.$model" />
    </panel>

    <panel title="Oświadczenia">
      <div class="row form-group">
        <div class="col-12">
          <w-checkbox :model="schema.data.criminalResponsibility">
            <span v-html="schema.data.criminalResponsibility.$title" />
          </w-checkbox>
        </div>
      </div>

      <hr />

      <div class="row form-group">
        <div class="col-12">
          <w-checkbox :model="schema.data.personalDataStatement">
            <span v-html="schema.data.personalDataStatement.$title" />
          </w-checkbox>
        </div>
      </div>

      <hr />

      <div class="row form-group">
        <div class="col-12">
          <w-checkbox :model="schema.data.contactStatement">
            <span v-html="schema.data.contactStatement.$title" />
          </w-checkbox>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';
import { documentFormMixin } from '@/mixins/document/documentForm';

import PersonWithPesel from '../PersonWithPesel.vue';
import SchoolPickerDuplikaty from '../SchoolPickerDuplikaty.vue';

// @vuese
// Formularz wniosku o wydanie duplikatu
export default {
  components: { ...components, Panel, PersonWithPesel, SchoolPickerDuplikaty },
  mixins: [documentFormMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },

  computed: {
    hasPesel() {
      return this.schema.data.tenderer.pesel.$model?.length === 11;
    },
    documentTypes() {
      const studentType = this.schema.data.tenderer.studentType.$model;
      if (!studentType) {
        return this.dictionary.documentTypes;
      }

      return this.dictionary.documentTypesByStudent[studentType];
    },
    schoolClassess() {
      return this.dictionary.schoolClassess;
    }
  },

  methods: {
    isDocumentTypeSelected(documentType) {
      return this.schema.data.details.documentType.$model.some(type => type === documentType.value);
    },

    documentYearModel(documentType) {
      var yearModel = this.schema.data.details.documentTypeData.$items.find(
        item => item.$item.$model.type === documentType.value
      );
      return yearModel && yearModel.$item.year;
    },

    toggleDocumentYear(documentType) {
      this.$nextTick(() => {
        if (this.isDocumentTypeSelected(documentType)) {
          this.schema.data.details.documentTypeData.$addRow({ type: documentType.value });
          return;
        }

        const index = this.schema.data.details.documentTypeData.$model.findIndex(
          year => year.type === documentType.value
        );
        if (index >= 0) {
          this.schema.data.details.documentTypeData.$removeRow(index);
        }
      });
    }
  }
};
</script>
